exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Loader-module__loader___3_uOT{font-size:40px;display:flex;align-items:center;justify-content:center;width:100%;height:100vh;color:#fece15;background:#fff}", ""]);

// exports
exports.locals = {
	"loader": "Loader-module__loader___3_uOT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/Loading/Loader.module.scss
// module id = fZP/
// module chunks = 0